import RescheduleModalTitle from '@components/reschedule-course-class/reschedule-modal-title'
import { FastlyImage } from '@components/common/image'
import { RESCHEDULE_CLASS_IMAGE_PATH } from '@lib/constants/reschedule-class'
import { formatTimeByTimezone } from '@lib/utils/date.utils'
import { DATE_TIME_FORMAT } from '@lib/constants/common'
import Button from '@components/atoms/button'
import classNames from 'classnames'

type Props = {
  lessonNumber: string | number
  lessonTitle: string
  onAttendClassNextTime: () => void
  onGoBack: () => void
  nextClassTimestamp: string
  selectedTimezone: string
  isTeacher: boolean
}

const NoSlotsAvailable = ({
  lessonNumber,
  lessonTitle,
  onAttendClassNextTime,
  onGoBack,
  nextClassTimestamp,
  selectedTimezone,
  isTeacher,
}: Props) => (
  <div className="flex flex-col space-y-5">
    <div className="self-center">
      <FastlyImage
        src={`${RESCHEDULE_CLASS_IMAGE_PATH}calendar-fail.png`}
        width={100}
        height={100}
        className="self-center"
      />
    </div>
    <RescheduleModalTitle
      lessonNumber={lessonNumber}
      lessonTitle={lessonTitle}
    />
    {isTeacher ? (
      <p className="text-xl leading-tight">
        Sorry,{' '}
        <span className="font-600">
          you don&apos;t have any available slot before your next class.
        </span>{' '}
        You can choose to take this class next time -{' '}
        <span className="font-600">
          {formatTimeByTimezone(
            nextClassTimestamp,
            selectedTimezone,
            DATE_TIME_FORMAT
          )}
        </span>
      </p>
    ) : (
      <p className="leading-tight">
        Sorry,{' '}
        <span className="font-600">
          teacher is not available before your next class
        </span>
        . If you want you can attend this class next time -{' '}
        <span className="font-600">
          {formatTimeByTimezone(
            nextClassTimestamp,
            selectedTimezone,
            DATE_TIME_FORMAT
          )}
        </span>
      </p>
    )}
    <div
      className={classNames('flex space-x-5', { 'justify-center': isTeacher })}
    >
      <Button
        variant={isTeacher ? 'solid' : 'outline'}
        intent={isTeacher ? 'success' : 'primary'}
        onClick={onAttendClassNextTime}
      >
        {isTeacher
          ? 'Schedule at next class time'
          : 'I will attend the class next time'}
      </Button>
      {!isTeacher && (
        <button
          className="focus:outline-none font-600 hover:underline text-orange"
          onClick={onGoBack}
        >
          Go back
        </button>
      )}
    </div>
  </div>
)

export default NoSlotsAvailable
